<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Historial Paciente</span>
        </v-col>
        <!-- <v-col cols="2" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('clientes.create')"
            dark
            color="#023145"
            width="140"
            class="float-right"
            @click="handleShowCreate"
          >
            Nuevo
          </v-btn>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_customer"
            label="Buscar"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchByEnter"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col>
        <!-- <v-col cols="3" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('clientes.filters')"
            dark
            color="#023145"
            outlined
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
            Ver Filtros
          </v-btn>
          <v-btn
            dark
            color="green"
            class="float-right mr-2"
            @click="handleDownload"
          >
            <v-icon class="mr-1" size="16">fas fa-download</v-icon>
            Descargar
          </v-btn>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="historial"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              show-select
              :single-select="true"
              @item-selected="handleSelectItem"
            >
              <template v-slot:top>
                <span
                  class="
                    ml-3
                    pt-3
                    pb-3
                    subtitle-1
                    font-weight-bold
                    w-title-table
                  "
                >
                  Historial
                </span>
                <v-divider></v-divider>
              </template>

              <!-- <template v-slot:item.fullname="{ item }">
                <span>{{ item.fullname }}</span>
                <span v-if="item.active" class="activo">
                  <v-icon size="11" color="#4CAF50">fas fa-check</v-icon>
                  activo
                </span>
                <span v-else class="inactivo">
                  <v-icon size="11" color="#F44336">fas fa-minus</v-icon>
                  inactivo
                </span>
                <br />
                <v-icon v-if="item.email" class="mr-1" size="13" color="#303197"
                  >fas fa-envelope</v-icon
                >
                <span class="font-italic email-company">
                  {{ item.email }}
                </span>
              </template> -->
              <template v-slot:item.detail="{ item }">
                <v-btn
                  icon
                  small
                  dark
                  color="blue"
                  @click="handleViewDetail(item)"
                >
                  <v-icon size="14">fas fa-bars</v-icon>
                </v-btn>
              </template>
              <!-- <template v-slot:item.type_document_id="{ item }">
                <span>{{ item.type_document.name }}</span>
              </template> -->
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <!-- <div class="text-center">
      <v-bottom-sheet
        v-model="show_options_crud"
        :hide-overlay="true"
        persistent
        :retain-focus="false"
      >
        <v-sheet class="text-center" height="85px">
          <div class="py-3">
            <v-btn
              v-if="this.$hasPermision('clientes.edit')"
              class="mt-3"
              dark
              color="blue"
              outlined
              @click="handleEdit"
            >
              <v-icon class="mr-2" size="16">fas fa-pen</v-icon>
              Editar
            </v-btn>
            <v-btn
              v-if="
                show_btn_active && this.$hasPermision('clientes.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="green"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
              Activar
            </v-btn>
            <v-btn
              v-if="
                !show_btn_active && this.$hasPermision('clientes.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="amber"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">fas fa-minus-circle</v-icon>
              Inactivar
            </v-btn>
            <v-btn
              v-if="this.$hasPermision('clientes.destroy')"
              class="ml-4 mt-3"
              dark
              color="red"
              outlined
              @click="handleDelete"
            >
              <v-icon class="mr-2" size="16">fas fa-times-circle</v-icon>
              Eliminar
            </v-btn>
            <v-btn
              v-if="this.$hasPermision('clientes.destroy')"
              class="ml-4 mt-3"
              dark
              color="green"
              outlined
              @click="handleChangeHistorialMedico"
            >
              Historial Medico
            </v-btn>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div> -->
    <create-update ref="createUpdate"></create-update>
    <Filters ref="filters"></Filters>

    <form-download ref="formDownload"></form-download>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ArrayTools from "../../../helpers/ArrayTools";
import CreateUpdate from "../../../components/customers/CreateUpdate";
import Filters from "../../../components/customers/Filters";
import FormDownload from "../../../components/customers/FormDownload";

export default {
  name: "HistorialPacientes",
  components: {
    CreateUpdate,
    Filters,
    OfficeLogin,
    FormDownload,
  },
  data() {
    return {
      search_customer: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Ventas",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "Fecha", value: "created_at", width: 200 },
        { text: "Estado", value: "state", width: 140 },
        { text: "Reporte", value: "state_report", width: 140 },
        { text: "", value: "detail", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    ...mapState("customers", ["customers"]),
    ...mapState("sales", ["customer_historial", "historial"]),
  },
  methods: {
    ...mapActions("customers", ["getCustomers", "change_status", "delete"]),
    ...mapActions("sales", ["getSales", "getHistorialPaciente"]),
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].active;
      }
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nuevo cliente", "create");
    },
    handleEdit() {
      let customer = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Modificar datos de cliente",
        "update",
        customer
      );
    },
    handleShowFilters() {
      this.$refs.filters.showForm("Filtrar datos de cliente");
    },
    async getAllHistorial() {
      await this.getHistorialPaciente({
        customer_id: this.customer_historial.id,
      });
    },
    handleInputSearchByEnter(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        this.handleSearch();
      }
    },
    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {
        fullname: this.search_customer,
      };
      await this.getHistorialPaciente(filters);
    },
    async handleChangeStatus() {
      let customer = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(customer);
    },
    async handleDelete() {
      let customer = this.selectedRows[0];
      await this.delete(customer);
      this.selectedRows = [];
      this.showOptionCrud();
    },
    async handleChangeHistorialMedico() {},
    handleDownload() {
      this.$refs.formDownload.showForm();
    },
    handleViewDetail() {
      let customer = this.selectedRows[0];
      this.selectedRows = [];
      this.$router.push("detail-pacientes");
    },
  },
  created() {
    // console.log(this.customer_historial);
    this.getAllHistorial();
  },
};
</script>

<style scoped></style>
